import { Box, Paper } from "@mui/material";

export default function QuestionImage({ imageUrl, extraImageUrl }) {
    return (
      <Box
        key={imageUrl}
        sx={{
          width: "100%",
          alignSelf: "flex-start",
          mb: { xs: 3, md: 0 },
        }}
      >
        <Paper
          elevation={2}
          sx={{
            p: 1,
            borderRadius: 2,
            overflow: "auto",
            bgcolor: "background.paper",
            border: "1px solid",
            borderColor: "divider",
            height: "100%",
            maxHeight: "90vh",
            textAlign: "center",
          }}
        >
          <img
            key={imageUrl}
            src={imageUrl}
            alt="Question group visual aid"
            style={{
              width: "auto",
              height: "auto",
              maxWidth: "100%",
            }}
          />
          {extraImageUrl && (
            <img
              key={extraImageUrl}
              src={extraImageUrl}
              alt="Question group visual aid"
              style={{
                width: "auto",
                height: "auto",
                maxWidth: "100%",
              }}
            />
          )}
        </Paper>
      </Box>
    );
}